import React, { createContext } from "react";
import "../style/chat/chat.scss";
import CurrentModelInfo from "../components/chat/CurrentModelInfo";
import CurrentModelContent from "../components/chat/CurrentModelContent";
import useScrollUp from "../hooks/useScrollUp";
import ChatContextContainer from "../components/chat/ChatContextContainer";

export const VideoContextRef = createContext(null);
export const AudioContextRef = createContext(null);
export const CanvasContextRef = createContext(null);
export const ChatWindowContextRef = createContext(null);
export const ZoomContextRef = createContext(null);
export const LastFrameContext = createContext(null);

export default function CurrentModel() {
  useScrollUp();

  return (
    <ChatContextContainer>
      <CurrentModelContent />
      <CurrentModelInfo />
    </ChatContextContainer>
  );
}
